// cachedViews信息
const cachedViewsKey = 'cachedViews'
function setCachedViews(cachedViews) {
  window.sessionStorage.setItem("cachedViews", JSON.stringify(cachedViews))

}
function getCachedViews() {
  let cachedViews = JSON.parse(window.sessionStorage.getItem("cachedViews") || '[]')
  return cachedViews
}

// noCachedViews信息
// const noCachedViews = 'noCachedViews'

function setNoCachedViews(noCachedViews) {
	window.sessionStorage.setItem("noCachedViews", JSON.stringify(noCachedViews))

}

function getNoCachedViews() {
	let noCachedViews = JSON.parse(window.sessionStorage.getItem("noCachedViews") || '[]')
	return noCachedViews
}


// VisitedViews信息
const visitedViewsKey = 'visitedViews'
function getVisitedViews() {
  let visitedViews = JSON.parse(window.sessionStorage.getItem("visitedViews") || '[]')
  return visitedViews
}

function setVisitedViews(visitedViews) {
  window.sessionStorage.setItem("visitedViews", JSON.stringify(visitedViews))
}



const tagsView = {
	state: {
		visitedViews: getVisitedViews(),
		cachedViews: getCachedViews(),
		noCachedViews: getNoCachedViews()
	},
	mutations: {
		ADD_VISITED_VIEWS: (state, view) => {
			let index = state.visitedViews.findIndex(v => v.path === view.path)
			if (index != -1) {
				state.visitedViews[index].query = view.query
			} else {
				state.visitedViews.push({
					path: view.path,
					name: view.name,
					fullPath: view.fullPath,
					title: view.meta.title || 'no-name',
					query: view.query
				})
				if (view.meta.keepAlive) {
					state.cachedViews.push(view.name)
				}
			}
			setCachedViews(state.cachedViews)
			setVisitedViews(state.visitedViews)
		},
		DEL_VISITED_VIEWS: (state, view) => {
			for (const [i, v] of state.visitedViews.entries()) {
				if (v.path === view.path) {
					state.visitedViews.splice(i, 1)
					break
				}
			}
			for (const i of state.cachedViews) {
				if (i === view.name) {
					const index = state.cachedViews.indexOf(i)
					state.cachedViews.splice(index, 1)
					break
				}
			}
			setCachedViews(state.cachedViews)
			setVisitedViews(state.visitedViews)
		},
		DEL_OTHERS_VIEWS: (state, view) => {
			for (const [i, v] of state.visitedViews.entries()) {
				if (v.path === view.path) {
					state.visitedViews = state.visitedViews.slice(i, i + 1)
					break
				}
			}
			for (const i of state.cachedViews) {
				if (i === view.name) {
					const index = state.cachedViews.indexOf(i)
					state.cachedViews = state.cachedViews.slice(index, i + 1)
					break
				}
			}
			setCachedViews(state.cachedViews)
			setVisitedViews(state.visitedViews)
		},
		DEL_ALL_VIEWS: state => {
			state.visitedViews = []
			state.cachedViews = []
			setCachedViews(state.cachedViews)
			setVisitedViews(state.visitedViews)
		}
	},
	actions: {
		addVisitedViews({ commit }, view) {
			commit('ADD_VISITED_VIEWS', view)
		},
		delVisitedViews({ commit, state }, view) {
			return new Promise(resolve => {
				commit('DEL_VISITED_VIEWS', view)
				resolve([...state.visitedViews])
			})
		},
		delOthersViews({ commit, state }, view) {
			return new Promise(resolve => {
				commit('DEL_OTHERS_VIEWS', view)
				resolve([...state.visitedViews])
			})
		},
		delAllViews({ commit, state }) {
			return new Promise(resolve => {
				commit('DEL_ALL_VIEWS')
				resolve([...state.visitedViews])
			})
		}
	}
}

export default tagsView



// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js